import { extendTheme } from '@chakra-ui/react';
import { rtaTheme as rtaUiTheme } from '@rtaoutdoorlivingllc/rta-ui';
import { theme } from '@chakra-ui/pro-theme';

import { initialColorMode } from './initial-color-mode';
import { zIndices } from './z-indices';

const proTheme = extendTheme(theme);

const extendedConfig = {
	colors: { ...proTheme.colors,
		brand: proTheme.colors.teal,
		brandOrange: '#E8622A' },
	fonts: {
		heading: '\'Arial\', -apple-system, system-ui, sans-serif',
		body: '\'Arial\', -apple-system, system-ui, sans-serif'
	},
	z: { ...zIndices },
	...initialColorMode
};

// Only what an rta-ui component actually reads is merged, never the whole rta-ui theme: its global
// styles and fonts would override this app's, and its scales carry Chakra's defaults, which would
// quietly replace the pro-theme's. Filtering to the rta-* keys leaves every existing scale untouched
// while making rta.* / rta-* resolve instead of silently dropping out.
const rtaScale = (scale: Record<string, unknown> = {}): Record<string, unknown> =>
	Object.fromEntries(Object.entries(scale).filter(([key]) => key.startsWith('rta-')));

const rtaUiTokens = {
	semanticTokens: rtaUiTheme.semanticTokens,
	space: rtaScale(rtaUiTheme.space),
	radii: rtaScale(rtaUiTheme.radii),
	fontSizes: rtaScale(rtaUiTheme.fontSizes),
	letterSpacings: rtaScale(rtaUiTheme.letterSpacings)
};

export const rtaTheme = extendTheme(extendedConfig, rtaUiTokens, proTheme);
